export const DELIVERY_INCOMPLETE_EXPORT_ID = 'delivery-incomplete';
export const DELIVERY_INCOMPLETE_TITLE = 'Entregas Incompletas';

export const LOCALIZED_PROPERTIES = {
  trip: 'Viaje',
  code: 'Codigo_Ruta',
  subRoute: 'Ruta',
  user: 'Usuario',
  numberOrder: 'Nro. Doc.',
  date: 'Fecha Entrega',
  shipToExternalKeyCode: 'Codigo_Cliente',
  shipToName: 'Cliente',
  materialCode: 'Codigo_Material',
  materialName: 'Material',
  soldQuantitySuggested: 'Cantidad_Solicitada',
  deliveredQuantity: 'Cantidad_Atendida',
  deliveredMinusSuggested: ' Cantidad_No_Atendida',

};
